import * as _ from "lodash";
import * as moment from "moment";
import * as React from "react";
import { DoctorPatient } from "../../containers/MyPatientsPage";
import { AppConstants } from "../../utils/AppConstants";
import AppUtils from "./../../utils/AppUtils";

import ConverseChat from "@curefit/converse-chat-sdk";
import { CONVERSE_SDK_EVENTS, eventDispatcher } from "@curefit/converse-chat-sdk";

import "@curefit/converse-chat-sdk/dist/converseChatSDK.css";
import { WhatsAppPatientInfo } from "../WhatsAppChatComponent";

export interface DoctorPatientCardProps {
    doctorPatient: DoctorPatient;
    unreadCount?: number;
    openChat: (twilioModeId: string, patient: any, identity: string) => void;
    openWhatsAppChat: (patientInfo: WhatsAppPatientInfo) => void;
    useWhatsAppChat: boolean;
    isActive?: boolean;
}

const DoctorPatientCard = (props: DoctorPatientCardProps) => {
    const doctorPatient = props.doctorPatient
    const hasChatExpired = doctorPatient.expiry && doctorPatient.expiry < Date.now()
    // const imageCard = <div className="name-initial">{doctorPatient.patientDetail.name[0].toUpperCase()}</div>
    let timeToDisplay = doctorPatient.lastCompletedConsultation ? AppUtils.getRelativeDay(doctorPatient.lastCompletedConsultation, "D/M/YY") + " | " + moment(doctorPatient.lastCompletedConsultation).format("h:mma") : "";
    let unreadMessageCount = !_.isNull(props.unreadCount) && !hasChatExpired ? props.unreadCount.toString() : "";
    let relativeDay = AppUtils.getRelativeDay(doctorPatient.lastChatTime, "D MMM Y");
    let time = moment(doctorPatient.lastChatTime).format("h:mm a");
    let textToDisplayOnChatButton = !hasChatExpired
        ? doctorPatient.lastChatTime ? (relativeDay === AppConstants.RelativeDayLabelConstant.TODAY || relativeDay === AppConstants.RelativeDayLabelConstant.YESTERDAY ? relativeDay + " at " + time : relativeDay) : ""
        : "Chat Expired";
    let chatButtonCssClasses = !_.isNull(props.unreadCount) && !hasChatExpired
        ? "chat-button unread"
        : hasChatExpired
            ? "chat-button disabled"
            : "chat-button";
    const gender = doctorPatient.patientDetail.gender ? doctorPatient.patientDetail.gender.toUpperCase()[0] : ""
    const isMobile = AppUtils.getIsMobile();
    const phoneNumber = !_.isNil(doctorPatient.patientDetail.userPhoneNumber) ?
        doctorPatient.patientDetail.userPhoneNumber : doctorPatient.patientDetail.phoneNumber
    const whatsAppPatientInfo: WhatsAppPatientInfo = {
        doctorId: doctorPatient.doctorId,
        name: doctorPatient.patientDetail.name,
        mobileNo: phoneNumber
    }
    return (
        <div className={`consultation-row ${props.isActive ? "active" : ""} `} key={doctorPatient.patientDetail.id} >
            <div className="patient-details">
                {/* {imageCard} */}
                <label className={`patient=name ${!isMobile && "brandon-bold"}`}>
                    {`${doctorPatient.patientDetail.name}, ${gender}, ${doctorPatient.patientDetail.age}`}
                </label>
            </div>
            <div className="time">{timeToDisplay}<span className="brandon-bold">{doctorPatient.hasUpcoming ? " (Upcoming)" : ""}{doctorPatient.hasInDraft ? " (Draft)" : ""}</span></div>
            {
                !props.useWhatsAppChat ?
                    <div className="chat brandon-bold">
                        {
                            !_.isEmpty(doctorPatient.twilioModeId) &&
                            <div className={chatButtonCssClasses} onClick={(event: any) => {
                                event.preventDefault();
                                !hasChatExpired && props.openChat(doctorPatient.twilioModeId, doctorPatient.patientDetail, doctorPatient.doctorMemberIdentity)
                            }}>
                                <span className={`glyphicon glyphicon-comment ${hasChatExpired ? "disabled" : ""}`}>
                                    <span className="count">
                                        {unreadMessageCount}
                                    </span>
                                </span>
                                {!isMobile && (
                                    <span className="chat-time">
                                        {textToDisplayOnChatButton}
                                    </span>
                                )}
                            </div>
                        }
                    </div> :
                    <div className="chat brandon-bold">
                        {
                            <img className={"whatsApp"} src={"/images/whatsapp.svg"} onClick={(event: any) => {
                                event.preventDefault();
                                props.openWhatsAppChat(whatsAppPatientInfo)
                            }}>
                            </img>
                        }
                    </div>
            }
        </div>
    )
}

export default DoctorPatientCard;